// Seeded PRNG. Every stochastic choice in the engine goes through here, so a
// piece is fully reproducible from its seed integer alone — the one thing the
// original Way of Code chapters could not do (33 of 82 called Math.random()).

export function mulberry32(seed) {
  let a = seed | 0
  return function () {
    a = (a + 0x6d2b79f5) | 0
    let t = Math.imul(a ^ (a >>> 15), 1 | a)
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296
  }
}

// Layers must not share a stream, or every layer draws the same "random" values.
export function deriveSeed(seed, salt) {
  let h = (seed ^ 0x9e3779b9) >>> 0
  for (let i = 0; i < salt.length; i++) {
    h = Math.imul(h ^ salt.charCodeAt(i), 0x01000193) >>> 0
  }
  return h | 0
}
